export default {
  accepted: {
    title: 'Assinatura aceite',
    description: 'Assinatura aceite. Obrigado por utilizar o nosso serviço de entregas!',
  },
  info: 'Tem uma entrega de',
  title: 'Verifique os seus dados:',
  fields: {
    name: 'Nome do destinatário:',
    phone: 'Telefone do destinatário:',
    address: 'Morada do destinatário:',
    'rx-number': 'Número da receita (Rx):',
  },
  'action-btn': 'Submeter',
  'empty-signature': 'Desenhe a sua assinatura antes de submeter.',
  'heading-required': 'Assinatura obrigatória',
  'heading-optional': 'Assinatura opcional',
  'heading-change': 'Já assinou. Quer alterar a sua assinatura?',
}
